import React, {useState} from 'react';
import {TitleAdmin, InputSignin} from './components';

// firebase
import firebase from 'library/firebase-config.js';
import 'firebase/auth';
const auth = firebase.auth();

// context
export const signinContext = React.createContext();

const AdminSignin = (props) => {
  const [siginForm, setSigninForm ] = useState({})

  const handleSubmit = (e) => {
    e.preventDefault();
    signin();
  }


  const signin = () => {
    const promise = auth.signInWithEmailAndPassword(siginForm.userEmail, siginForm.userPassword);
    promise.catch(e => alert(e.message));
  }

  return (
    <div className="AdminSignin bg-admin">
      
      <div className="admin-header">
        <div className="con admin">
          <TitleAdmin title = "로그인" className = "title-signin"/>
        </div>
      </div>

      <div className="admin-contents">
        <div className="con admin">
          <signinContext.Provider value = {{setSigninForm, siginForm}}>
            <form action="" className="admin-signin-form AdminSection" onSubmit = {handleSubmit}>
              <InputSignin 
                label = "이메일" 
                placeholder = "이메일" 
                type = "email"
                name = "userEmail"
                className = "admin-signin-userEmail"
              />
              <InputSignin 
                label = "비밀번호" 
                placeholder = "비밀번호" 
                type = "password"
                name = "userPassword"
                className = "admin-signin-userPassword"
              />

              <InputSignin 
                label = ""
                placeholder = "로그인" 
                type = "submit"
                name = "userSubmit"
                value = "로그인"
                className = "admin-signin-userSubmit"
              />

            </form>
          </signinContext.Provider>
          
        </div>
      </div>
    </div>
  );
}

export default AdminSignin;